import { Text } from 'blaze-ui/Text/Text'
import { useMediaFileProviderData } from 'hooks/queries/mediaFiles/useMediaFileProviderData'
import Styles from './AttributionSummary.module.scss'
import { Separator } from 'components/Menu/Separator'
import { GettyImagesProviderData, FreepikProviderData, PexelsProviderData } from 'types'

interface Props {
  mediaFileId: string
}

export const GettyImagesSummary = ({ provider_data }: { provider_data: GettyImagesProviderData }) => {
  const { title, artist, collection_name } = provider_data
  return (
    <>
      {title && <Text variant="largeList">{title}</Text>}
      {artist && collection_name && (
        <Text variant="metadata">
          By {artist} / {collection_name}
        </Text>
      )}
      <Text variant="metadata">From Getty Images</Text>
    </>
  )
}

export const FreepikSummary = ({ provider_data }: { provider_data: FreepikProviderData }) => {
  const { title, author_name } = provider_data
  return (
    <>
      {title && <Text variant="largeList">{title}</Text>}
      {author_name && <Text variant="metadata">By {author_name}</Text>}
      <Text variant="metadata">From Freepik</Text>
    </>
  )
}

export const PexelsSummary = ({ provider_data }: { provider_data: PexelsProviderData }) => {
  const { user_name } = provider_data
  return (
    <>
      {user_name && <Text variant="metadata">By {user_name}</Text>}
      <Text variant="metadata">From Pexels</Text>
    </>
  )
}

export const AttributionSummary = ({ mediaFileId }: Props) => {
  const { data } = useMediaFileProviderData(mediaFileId)

  if (!data) return null

  const { provider, provider_data } = data

  if (!provider || !provider_data) return null

  return (
    <>
      <div className={Styles.attributionSummary}>
        {provider === 'gettyimages' && <GettyImagesSummary provider_data={provider_data as GettyImagesProviderData} />}
        {provider === 'freepik' && <FreepikSummary provider_data={provider_data as FreepikProviderData} />}
        {provider === 'pexels' && <PexelsSummary provider_data={provider_data as PexelsProviderData} />}
      </div>
      <Separator />
    </>
  )
}
